import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function PaymentPending() {
  const { logout } = useAuth();
  return (
    <Box 
      sx={{
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        backgroundColor: '#f5f5f5'
      }}
    >
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Payment Pending
        </Typography>
        <Typography variant="body1">
          Your account has been created, but is awaiting payment.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Please complete the payment process. If you have already paid, the system will update shortly.
        </Typography>
        <Button variant="contained" onClick={logout} sx={{ mt: 3 }}>
          Log Out
        </Button>
      </Paper>
    </Box>
  );
}
